import React from "react";
import { Navigate } from "react-router";
import { paths } from "src/utils/common";

export const HomePage: React.FC = () => {

  return <Navigate to={paths?.getStart} />
}